<template lang="pug">
  div
    .d-flex
      v-autocomplete(
        v-model='numeroTicket'
        :items='tickets'
        label="Listado de tickets disponibles"
        placeholder="Realiza la busqueda por la desripción"
        dense,
        item-value="numero"
        item-text="numero"
        return-object
        solo
        hide-details,
        @change="seleccionarTicket"
      )
        template(v-slot:selection='data')
          .d-flex(v-bind='data.attrs')
            span.font-weight-700.success--text {{ `#${data.item.numero}` }},
            span.font-weight-700 &nbsp; {{ data.item.razonSocial }} &nbsp;
            span.grey--text.font-size-11(v-if="data.item.serie") - &nbsp; {{ data.item.serie }} &nbsp;
          //- span.grey--text.font-size-11 - &nbsp; {{ data.item.modelo }}
        template(v-slot:item='data')
          //- v-list-item-avatar(v-if="!noAvatar")
          //-   avatar-perfil(:is-fetch="true",  :usuario="data.item.usuario")
          v-card.elevation-0(width="520")
            ticket-summary-info.animated.fadeInUp.faster(
              :key="data.item.numero"
              :ticket="data.item"
              :handler="true",
              @href="() => {}"
            )
          //- v-list(dense)
          //-   v-list-item-content
          //-     .d-flex.ai-center.jc-center
          //-       v-list-item-content.ml-2
          //-         v-list-item-title.font-size-12(v-html='data.item.razonSocial')
          //-         v-list-item-subtitle.font-size-11.text-muted(v-html='data.item.usuario')
          //-       .d-flex
          //-         v-chip(:color="data.item.numeroInformeTecnico ? 'success' : 'primary'"  small text-color='white')
          //-           v-icon(left='', size="8")
          //-             | circle
          //-           span.font-weight-700.font-size-11(v-html='data.item.numero')
</template>
<script>
import { apiGet, notify } from '../util/general'
import avatarPerfil        from './c_avatar_perfil'
import TicketSummaryInfo  from '@/components/c_item_ticket_lista'
export default {
  components : {
    'avatar-perfil'      : avatarPerfil,
    'ticket-summary-info': TicketSummaryInfo
  },
  props : {
    toCita : {
      type   : Boolean,
      default: false
    },
    noAvatar : {
      type   : Boolean,
      default: false
    },
    numero : {
      type   : Number,
      default: 0
    }
  },
  data () {
    return {
      numeroTicket : this.numero || 0,
      tickets : []
    }
  },
  created () {
    var vm = this
    vm.fetchTickets()
  },
  computed : {
    isMovil () {
      var vm = this
      return vm.$vuetify.breakpoint.smAndDown
    }
  },
  methods : {
    seleccionarTicket (data) {
      var vm = this
      var titulo = `${data.razonSocial}`
      if (data.serie)  titulo += ` - ${data.serie}`
      // if (data.modelo)  titulo += ` - ${data.modelo}`
      data.titulo = titulo
      vm.$emit('selected', data)
    },
    fetchTickets () {
      var vm  = this
      var url = ''
      var obj = {}
      if (vm.toCita) {
        url = '/ticket/obtener/dispobibles/para/cita'
        obj = {}
      }
      if (!url) {
        notify(vm, 'error', 'Error', 'Los parametros enviados no son validos')
        return
      }
      vm.$store.dispatch('transaccion', { isProceso : true, message : 'Obteniendo tickets disponibles' })
      apiGet(vm, url, obj, function (data) {
        for (var i = 0; i < data.lista.length; i++) {
          vm.tickets.push(data.lista[i])
        }
      }, function (err) {
        notify(vm, 'error', 'Error', err.message)
      }, function () {
        vm.$store.dispatch('transaccion', { isProceso : false })
      })
    }
  }
}
</script>




// WEBPACK FOOTER //
// c_listado_tickets_seleccionar.vue?f4ef4442